<app-header></app-header>

<div class="wrapper">
  <app-side-nav></app-side-nav>
  <div class="content-container" [class.show-block-detail]="showBlockDetail">
    <app-timeline></app-timeline>
    <app-block-detail *ngIf="block" [block]="block"></app-block-detail>
  </div>
</div>
